var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card shadow-sm" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("static-loading-indicator-icon", {
            attrs: { loading: _vm.$store.getters.shouldLoadLocal }
          }),
          _vm._v(" "),
          !_vm.$store.getters.shouldLoadLocal
            ? _c(
                "div",
                [
                  _c("h3", { staticClass: "card-title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("pages.subscription.start.questions.title"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "card-text",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("pages.subscription.start.questions.safety_text")
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _vm._l(_vm.questions, function(question, i) {
                    return _c("div", { key: i, staticClass: "mt-4" }, [
                      _c("h5", { staticClass: "font-weight-lighter" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(question.text) +
                            "\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check-inline" }, [
                        _c("label", { staticClass: "form-check-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: question.answer,
                                expression: "question.answer"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: { type: "radio" },
                            domProps: {
                              value: true,
                              checked: _vm._q(question.answer, true)
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(question, "answer", true)
                              }
                            }
                          }),
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "pages.subscription.start.questions.answer_yes"
                                )
                              ) +
                              "\n                                "
                          ),
                          _c("i", { staticClass: "input-helper" })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check-inline" }, [
                        _c("label", { staticClass: "form-check-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: question.answer,
                                expression: "question.answer"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: { type: "radio" },
                            domProps: {
                              value: false,
                              checked: _vm._q(question.answer, false)
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(question, "answer", false)
                              }
                            }
                          }),
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "pages.subscription.start.questions.answer_no"
                                )
                              ) +
                              "\n                                "
                          ),
                          _c("i", { staticClass: "input-helper" })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("hr")
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "alert alert-secondary border-dark shadow-sm mt-5 mb-5"
                    },
                    [
                      _c("p", {
                        staticClass: "card-text",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "pages.subscription.start.questions.safety_bottom_text"
                            )
                          )
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-dark",
                      class: { "btn-disabled": !_vm.hasAnsweredAllQuestions },
                      attrs: { disabled: !_vm.hasAnsweredAllQuestions },
                      on: { click: _vm.saveAnswers }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("actions.update")) +
                          "\n                    "
                      )
                    ]
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }